export const bloodGroup = [
    'O+',
    'O-',
    'A+',
    'A-',
    'B+',
    'B-',
    'AB+',
    'AB-',
];

export const RolesOfUsers = [
    "Admin",
    "Doctor",
    "AsstDoctor",
    "Receptionist",
    "Pharmacist",
];

export const salute = [
    "Mr.",
    "Mrs.",
    "Miss",
    "Baby",
    "Master",
    "Dr.",
    "Prof.",
    "Ms.",
    "Mx",
    "Sir",
    "Madam",
    "Rev.",
    "Hon.",
];

export const GenderList = [
    {
        name: 'Male',
        value: "M"
    },
    {
        name: 'Female',
        value: "F"
    },
];

export const MaritalStatus = [
    {
        name: 'Unmarried'
    },
    {
        name: 'Married'
    }
];
